import { render } from "./LayoutFrame.vue?vue&type=template&id=b68e539c"
import script from "./LayoutFrame.vue?vue&type=script&lang=js"
export * from "./LayoutFrame.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sjoshi6/git/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__